import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { reducerRegistry, sagaRegistry, checkOauthToken } from 'coral-utility';
import Connect from './connect';
import connectReducer from 'state/ducks/connect/reducers';
import connectSaga from 'state/ducks/connect/sagas';
import navigationReducer from 'state/ducks/navigation/reducers';
import navigationSaga from 'state/ducks/navigation/sagas';
import { getNavigationAction } from 'state/ducks/navigation/actions';

/** Register Reducers and sagas for a specific feature */
reducerRegistry.register('connect', connectReducer);
sagaRegistry.register('connect', connectSaga);
reducerRegistry.register('navigation', navigationReducer);
sagaRegistry.register('navigation', navigationSaga);

const mapStateToProps = (state: any) => ({
  connect: state.connect,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      checkOauthToken,
      getNavigationAction,
    },
    dispatch
  );

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(Connect));
